import React from 'react'
import { useForTablet, Navbar, DocumentHead } from '@sketch/components'
import { ShareWithoutVersion } from '../../../versioning'
import BackButton, {
  useBackButton,
} from '../../../shares/components/BackButton'
import HeaderBadge from '../../../shares/components/HeaderBadge'
import * as S from './PrototypeHeader.styles'
import { PrototypeFlowSelector } from '../PrototypeFlowSelector'
import { PrototypeControls } from '../PrototypeControls'
import { ArtboardLink } from '../ArtboardLink'
import { ResizeModeSelector } from '../ResizeModeSelector'
import { NavbarEnterFullScreenButton } from '../NavbarEnterFullScreenButton'
import { SharePrototype } from '../SharePrototype'
import { usePrototypeContext } from '../../hooks'
import { AnnotationButton } from '../AnnotationButton'
import { AnnotationMobileMenu } from '../AnnotationMobileMenu'
import { useIsAnnotationContextAvailable } from '../../../annotations/hooks'
import { useRouteMatch } from 'react-router-dom'
import { isPreviewRoute } from '@sketch/modules-common'

type PrototypeHeaderProps = {
  setSidebarLeftOpen?: React.Dispatch<React.SetStateAction<boolean>>
  share: ShareWithoutVersion
}

export const PrototypeHeader: React.FCC<PrototypeHeaderProps> = ({
  setSidebarLeftOpen,
  share,
}) => {
  const isTabletAndBigger = useForTablet()
  const { link: shouldRenderBackButton } = useBackButton()
  const { isFullscreen } = usePrototypeContext()
  const { path } = useRouteMatch()
  const isPreviewView = isPreviewRoute(path)

  /**
   * On Annotation context the "disabled" checks if the user
   * has commenting permissions if it has not there's no
   * point on showing this
   */
  const annotationContextAvailable = useIsAnnotationContextAvailable()
  const showAnnotationItems = annotationContextAvailable

  if (isFullscreen) {
    return null
  }

  return (
    <Navbar data-testid="prototype-header">
      <Navbar.Section>
        <DocumentHead title={`${share.name} Prototypes`} />
        <HeaderBadge
          workspace={share.workspace}
          setSidebarLeftOpen={setSidebarLeftOpen}
        />
        {isTabletAndBigger && shouldRenderBackButton && (
          <S.BackButtonItem>
            <BackButton />
          </S.BackButtonItem>
        )}
        <PrototypeFlowSelector />
      </Navbar.Section>

      {!isTabletAndBigger && (
        <S.Item>
          <ArtboardLink />
        </S.Item>
      )}

      {!isTabletAndBigger && showAnnotationItems && (
        <S.Item>
          <AnnotationMobileMenu />
        </S.Item>
      )}

      {isTabletAndBigger && (
        <Navbar.Section align="end">
          <S.Item>
            <PrototypeControls />
          </S.Item>
          <S.Item>
            <ResizeModeSelector />
          </S.Item>
          {!isPreviewView && (
            <>
              <S.Item>
                <SharePrototype />
              </S.Item>
              <S.Item>
                <ArtboardLink />
              </S.Item>
            </>
          )}

          <S.Item>
            <NavbarEnterFullScreenButton />
          </S.Item>

          {showAnnotationItems && (
            <S.Item>
              <AnnotationButton />
            </S.Item>
          )}
        </Navbar.Section>
      )}
    </Navbar>
  )
}
